import type { FluidOwaSource } from '../enums/FluidEnums';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isCollabSpaceReadEnabled } from './isCollabSpaceReadEnabled';
import type { MailboxInfo } from 'owa-client-types';
import { isEduConsolidated } from './isEduConsolidated';

export function isCollabSpaceEnabledForSource(
    fluidOwaSource: FluidOwaSource,
    mailboxInfo: MailboxInfo
): boolean {
    if (
        !isGlobalFeatureEnabled('cal-cmp-fluidCollaborativeSpaceEdu') &&
        isEduConsolidated(mailboxInfo)
    ) {
        return false;
    }
    switch (fluidOwaSource) {
        case 'CalendarReadingPane':
        case 'MailCalendarCard':
            return isCollabSpaceReadEnabled();
        case 'CalendarCompose':
            return (
                // Functionality restricted to Teams client as per EU settlement
                // cal-disable-meeting-notes will be rolled out to "true" for everything except Teams
                !isGlobalFeatureEnabled('cal-disable-meeting-notes') &&
                isGlobalFeatureEnabled('cmp-prague') &&
                isGlobalFeatureEnabled('cal-cmp-fluidCollaborativeSpace')
            );
        default:
            return false;
    }
}
